import React from 'react'
import ReactDOM from "react-dom";
import Carousel from "react-elastic-carousel";
import divi from '../assets/divi.svg' 
import img2 from '../assets/img-2.png'
const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 3 },
  ];

const MostReviewSlider = () => {
  return (
    <>
    <div className='md:w-[80%] mx-auto '>
    <center>
<h1 className='text-center text-xl text-gray-700 font-bold pt-6'>Most Reviewed Courts</h1>
<img src={divi} alt='divider' className='-mt-8' />
</center>
      <div className="App">
        <Carousel breakPoints={breakPoints}>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
          <div>
          <center>
              <img src={img2} alt='img' />
              <div className='flex justify-center mt-2 '>
<form className=' '>

    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>
    <i class="fa-solid fa-star text-xl   text-[#409BF5]"></i>

</form>

<p className='text-gray-900 text-xs pt-[6px] ml-2'>(10k)  </p>
</div>
<h3 className='text-xs font-bold text-[#272C34] pt-2'>Como, Italy</h3>
          </center>
          </div>
 
        </Carousel>
      </div>
      </div>
    </>
  )
}

export default MostReviewSlider